// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";

interface OwnProps {
    title: string;
    invoiceNumber: string;
    // xng-change: add google event
    dataLayerEvent?: any;
}

type Props = OwnProps;

const InvoiceDetailPageTypeLink: React.FunctionComponent<Props> = ({
    title,
    invoiceNumber,
    // xng-change: add google event
    dataLayerEvent,
}) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: "InvoiceDetailsPage",
            overrideTitle: title,
            queryString: `invoiceNumber=${invoiceNumber}`,
            // xng-change: add google event
            dataLayerEvent,
        },
    });
};

export default InvoiceDetailPageTypeLink;
